import type { Properties } from '@mend/types/properties';
import type { Response } from '../../types/common.ts';

import { api } from '../http-clients.ts';

export function getProperties(): Promise<Properties> {
  return api
    .get<Response<{ properties: Properties }>>('/property')
    .then((res) => res.data.payload.properties);
}
